import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import type { PapiDeviation, PapiOriginalsResponse } from '@wix/da-papi-types';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import OrdersListItem from './OrdersListItem';

import s from './OrdersList.scss';

export interface Props {
  className?: string;
  heading?: React.ReactNode;
  parentDeviation?: PapiDeviation;
  results: PapiOriginalsResponse[];
  fetchNext: () => void;
  hasMore?: boolean;
  showTitle?: boolean;
  showStatus?: boolean;
}

const OrdersList: React.FC<Props> = ({
  className,
  heading,
  parentDeviation,
  results,
  hasMore,
  fetchNext,
  showTitle = true,
  showStatus = false,
}) => {
  const { t } = useTranslation();

  return (
    <section className={cn(s['root'], className)}>
      {heading}
      <div className={s['list']}>
        {results.map((result, idx) => {
          return (
            <OrdersListItem
              key={idx}
              order={result}
              parentDeviation={parentDeviation}
              showTitle={showTitle}
              showStatus={showStatus}
            />
          );
        })}
      </div>
      {hasMore && (
        <div className={s['pagination']}>
          <TextButton variant="main" size="small" onClick={fetchNext}>
            {t('common.seeMore')}
          </TextButton>
        </div>
      )}
    </section>
  );
};

OrdersList.displayName = 'OrdersList';

export default OrdersList;
